import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { UsersComponent } from 'src/app/admin/users/users.component';
import { map } from 'rxjs/operators';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => UserPickerComponent) },
  ],
  selector: 'user-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class UserPickerComponent extends ExternalSelectorComponent {

  @Input() preferenceHints: { [userId: number]: string | string[] };

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(UsersComponent, {
      data: {
        selectionMode: true,
        defaultSearch: this.defaultSearch,
        preferenceHints: this.preferenceHints,
      }
    }).afterClosed();
  };


}
